'use client';
import { MobileHeaderBackButton, Title, IConversationFansResponse, Avatar } from '@ui/components';
import { usePostHogFeatureFlag } from '@ui/hooks';
import { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

interface IMobileHeaderContent {
  onBack(): void;
  title: string;
  subTitle?: string;
  leftItem?: JSX.Element;
  titleClassName?: string;
  subTitleClassName?: string;
  backStroke?: string;
  theme?: 'light' | 'dark';
  showLogo?: boolean;
  fansData?: IConversationFansResponse;
}
export function MobileHeaderContent({
  title,
  onBack,
  leftItem,
  titleClassName,
  backStroke,
  theme = 'light',
  subTitle,
  subTitleClassName,
  showLogo,
  fansData,
}: IMobileHeaderContent) {
  const isDark = theme === 'dark';
  const isGroupMessage = useMemo(() => {
    return fansData && fansData?.fans && fansData?.fans?.length > 1;
  }, [fansData]);
  const isMessageRecipientsFlagEnabled = usePostHogFeatureFlag('message-recipient');

  return (
    <>
      <div className="basis-1/5">
        <MobileHeaderBackButton
          isDark={isDark}
          onBack={onBack}
          backStroke={backStroke}
          showLogo={showLogo}
        />
      </div>
      <div className="w-full">
        <Title
          type="sm"
          className={twMerge('text-center font-bold', isDark ? 'text-white' : '', titleClassName)}>
          {title}
        </Title>
        {subTitle && (
          <Title
            type="xs"
            className={twMerge(
              'text-center text-xs md:text-sm w-[170px] overflow-hidden text-ellipsis text-nowrap',
              isDark ? 'text-white' : '',
              subTitleClassName,
            )}>
            {subTitle}
          </Title>
        )}
      </div>
      <div className="flex basis-1/5 justify-end">{leftItem}</div>
      {isGroupMessage && isMessageRecipientsFlagEnabled && (
        <div className="border-note mb-4 flex w-[90%] items-center justify-center pb-1 backdrop-blur-lg">
          <div className="flex flex-col md:flex-row items-start md:items-center ">
            <div className="flex -space-x-2 overflow-hidden ">
              {fansData?.fans?.slice(0, 5).map((fan) => (
                <Avatar
                  key={fan?.id}
                  src={fan?.avatar_url}
                  size="xs"
                  className="border border-gray-100"
                />
              ))}
            </div>
            {fansData?.fans && fansData?.fans?.length >= 5 && (
              <div className="text-xs font-medium text-note">
                {fansData?.total_records > 5 && <span>+{fansData?.total_records - 5} more </span>}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
